module.exports = __webpack_public_path__ + "static/media/patch-sparkle.8b563bfb.webp";